<template>
  <div class="wrapper">
    <div class="animated fadeIn">

      <b-row>
        <b-col >
          <b-card>
            <div slot="header" >
              <strong>Withdraw History</strong>
            </div>



            <b-table class="table-outline" responsive="sm":items="tableItems" :fields="tableFields" head-variant="light">
              <div slot="id" slot-scope="item" @click="onSelect(item)">
                {{item.index+1}}
              </div>

              <div slot="action" slot-scope="item">
                <!--<b-button size="gl" variant="primary" class="mr-sm-1"><i class="fa fa-dot-circle-o"></i> Submit</b-button>-->
                <!--<b-button size="gl" variant="danger" ><i class="fa fa-clipboard"></i> Reset</b-button>-->
                <i class="fa fa-clipboard font-2xl"></i>
                <!--<b-form-input id="reason" type="text" autocomplete="reason"  @change="signalChange(item,$event)" ></b-form-input>-->
              </div>
            </b-table>

            <!--<div slot="footer" class="text-right">-->
              <!--<b-button size="gl" variant="primary" @click="this.createData" class="mr-sm-1"><i class="fa fa-dot-circle-o"></i> Submit</b-button>-->
              <!--<b-button size="gl" variant="danger" @click="this.clearData"><i class="fa fa-ban"></i> Reset</b-button>-->
            <!--</div>-->

          </b-card>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
  import Service from "../../../service/api"

  export default {
    name: 'WithdrowHistory',
    data () {
      return {
        title:"DIVISION OF REGISTRAR, MAE FAH LUANG UNIVERSITY",
        studentInfo:{},
        tableFields: {
          ACADYEAR: {
            label: 'Acadyear',
            class: 'text-center'
          },
          SEMESTER: {
            label: 'Semester',
            class: 'text-center'
          },
          COURSETITLE: {
            label: 'Course',
            class: 'text-left'
          },
          CREDITTOTAL: {
            label: 'Credit',
            class: 'text-center'
          },
          LASTSTATUS: {
            label: 'Last Status',
            class: 'text-center'
          },
          REMARK: {
            label: 'Remark',
            class: 'text-center'
          },
        },
        tableItems:[],
      }
    },

    methods: {
      onLoad(){
        Service.onStudentinfo().then((response) => {
          this.studentInfo = response.data.data[0]
        }).catch((error) => {
          console.log(error);
        });
      },

      onLoad_Result(){
        Service.onResultHistory_Student().then((response) => {
          console.log(response.data.data);
          this.tableItems = response.data.data

        }).catch((error) => {
        });
      },
    },
    mounted() {
      this.onLoad();
      this.onLoad_Result();
    },
    created () {

    },
  }


</script>
<style>

</style>
